import { render, staticRenderFns } from "./motherPackage.vue?vue&type=template&id=b52723a0&scoped=true&"
import script from "./motherPackage.vue?vue&type=script&lang=js&"
export * from "./motherPackage.vue?vue&type=script&lang=js&"
import style0 from "./motherPackage.vue?vue&type=style&index=0&id=b52723a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b52723a0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\sdk_manage_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b52723a0')) {
      api.createRecord('b52723a0', component.options)
    } else {
      api.reload('b52723a0', component.options)
    }
    module.hot.accept("./motherPackage.vue?vue&type=template&id=b52723a0&scoped=true&", function () {
      api.rerender('b52723a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/packagingManagement/motherPackage.vue"
export default component.exports